/** Clears ephemeral client state that may reference a previous tenant. */
export function clearTenantScopedSessionState(): void {
  try {
    sessionStorage.clear();
  } catch {
    // ignore private browsing / storage errors
  }
}
